import { VolopAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainVolopsSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainVolopSearchRouteData = {
  lang: UserLocale;
  q: string;
  radius?: number | 'auto' | null;
  filters?: VolopAlgoliaApiQueryFilters;
};

export function getMainVolopsSearchRoutePath(data: MainVolopSearchRouteData) {
  const { lang, filters, q, radius } = data;

  const segment = HOME_PAGE_SLUGS.VOLOP[lang];

  let queryParams: { q: string; radius?: number | 'auto' } = {
    q,
  };

  if (radius) {
    queryParams = {
      ...queryParams,
      radius,
    };
  }

  if (filters) {
    queryParams = {
      ...queryParams,
      ...transformSearchFiltersToQueryParams(filters),
    };
  }

  return mainVolopsSearchRouteReference.with({ lang, segment, ...queryParams });
}
